import * as React from 'react';
import { useContext } from 'react';
import { RolesTypes } from '../types/acl';
import Page404 from './Page404';

export type UserCanTypeProps = 'view' | 'actions' | 'exports';

export interface UserCanProps {
  section: keyof RolesTypes;
  type: UserCanTypeProps;
  permission: string | string[];
  render404?: boolean;
}
/*
export interface PermissionSet {
  view?: string[];
  actions?: string[];
  exports?: string[]; // Aggiunto per completezza basandomi sul contesto 'UserCanTypeProps'
} */

export const isSupportStaff = (email: string) =>
  email.startsWith('amansutti')
  || email.startsWith('lliusso')
  || email.startsWith('mmaniera')
  || email.startsWith('nfranceschinis');

export interface UserContextValue {
  user: ({ isStaff: boolean, isSupportStaff: boolean } & RolesTypes) | null;
  setUser: (value: ({ isStaff: boolean, isSupportStaff: boolean } & RolesTypes) | null) => void;
  userCan: (props: UserCanProps) => boolean;
  userPermissions: RolesTypes | null;
}

export const UserContext = React.createContext<UserContextValue>({
  user: null,
  setUser: () => {},
  userCan: () => false,
  userPermissions: null,
});

const ACLWrapper: React.FC<UserCanProps & {children: JSX.Element}> = (props) => {
  const { userCan } = useContext(UserContext);
  const {
    section, permission, type, children, render404,
  } = props;

  const localConfig = localStorage.getItem('test-components-config');
  const debugConfig = localConfig && JSON.parse(localConfig);
  const { debugAcl } = debugConfig || {};

  return userCan({ section, type, permission })
    ? debugAcl // @todo add && user?.isStaff
      ? (
        <section
          className="debug-acl debug-acl-allowed"
          data-title={`${section} - ${type} - ${permission}`}
        >
          {children}
        </section>
      )
      : children
    : debugAcl // @todo add && user?.isStaff
      ? (
        <div
          className="debug-acl debug-acl-not-allowed"
          data-title={`${section} - ${type} - ${permission}`}
        >
          {`No permissions for: ${section} ${type} ${permission}`}
        </div>
      )
      : render404
        ? <Page404 />
        : null;
};

export const ACLWrapper404: React.FC<UserCanProps & { children: JSX.Element }> = (props) => {
  const { children, ...rest } = props;

  return (<ACLWrapper {...rest} render404>{children}</ACLWrapper>);
};

export default ACLWrapper;
